import React from 'react';
import { Grid } from '@mui/material';

import SalesPersonPagePanel from '~/components/SalesPersonPanelPiloto/SalesPersonPagePanel';
import OrderListPanel from '~/components/OrderListPanel';
import * as Style from './styles';

const DesktopLayout = ({
    salesNumber,
    balanceText,
    quota,
    salesPercentage,
    indicatorsText,
    panelLoaded,
    ordersLoaded,
    orders,
    aggregatedOrdersByPeriod,
    brandFilter,
    setBrandFilter,
    chartData,
    dateRange,
    dataSource,
    isVendedorView
}) => {

    const DATA_SOURCES = {
    LOJA: 'Loja',
    VENDEDOR: 'Vendedor',
};

    const RootContainer = dataSource === DATA_SOURCES.LOJA ? Grid : Style.Container;

    return (
        <>
            <RootContainer container>
                <Grid item xs={12}>
                    <SalesPersonPagePanel
                        balanceText={balanceText}
                        indicatorsText={indicatorsText}
                        panelLoaded={panelLoaded}
                        aggregatedOrdersByPeriod={aggregatedOrdersByPeriod}
                        chartData={chartData}
                        dateRange={dateRange}
                        salesNumber={salesNumber}
                        quota={quota}
                        salesPercentage={salesPercentage}
                        isVendedorView={isVendedorView}
                    />
                </Grid>
                <Style.LateralPanelContainer item xs={12}>
                    <OrderListPanel
                        orders={orders}
                        ordersLoaded={ordersLoaded}
                        brandFilter={brandFilter}
                        setBrandFilter={setBrandFilter}
                    />
                </Style.LateralPanelContainer>
            </RootContainer>
        </>
    );
};

export default DesktopLayout;